<template>
  <div class="map-archive-link__container">
    <a class="map-archive-link" :href="url" v-text="texts.archiveLinkText" />
  </div>
</template>

<script>
export default {
  name: 'ArchiveLink',

  props: {
    archiveLink: {
      type: String,
      default: '',
    },
    citySlug: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      url: `${this.archiveLink}${this.citySlug}/`,
      texts: theme_vars.mapText,
    };
  },
};
</script>
